import { Box, styled } from '@mui/material'

export const StyledPageWrapper = styled('main')(({ theme }) => ({
  minHeight: '100vh',
  backgroundColor: theme.palette.white.main,
  padding: '0px 20px 0px 20px',
}))

export const StyledContainer = styled(Box)(({ theme }) => ({
  maxWidth: '100%',
  margin: '0 auto',
  [theme.breakpoints.up('md')]: {
    maxWidth: '850px',
  },
}))
